export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const CHANGE_FORGOT_PASSWORD_FORM = "CHANGE_FORGOT_PASSWORD_FORM";
export const CLEAR_API_ERROR_MESSAGE = "CLEAR_API_ERROR_MESSAGE";
export const RESET_FORGOT_PASSWORD_FORM = "RESET_FORGOT_PASSWORD_FORM";